<template>
  <Page :rounded="false">
    <div class="dash-w-full dash-bg-white dash-py-6 !flex !justify-center">
      <img :src="branding.logoPrimary" :alt="branding.appName" class="dash-h-8" />
    </div>
    <ContentBanner
      variant="pageError"
      title="This page is Unavailable"
      message="It may have been deactivated or deleted by an admin. Please contact your admin for assistance."
      class="!mt-64"
    />
  </Page>
</template>

<script setup>
import { ContentBanner, Page, Section } from '@dashhudson/dashing-ui';
import { branding } from '@/config';
</script>
